import i18n from "../../../../constants/i18n";
import { QA_IOS_RECEIPT_TOKENS_HEADERS } from "../../../../constants/table-custom-headers/QA";
import getQAStore from "../../../../stores/qa";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const ObtainIosReceiptTokensData = withLiteObserverAndTheme(() => {
  const QaStore = getQAStore();
  const receiptTokenData = QaStore.receiptTokenData.get();
  return (
    <Et3Table
      columns={QA_IOS_RECEIPT_TOKENS_HEADERS}
      rows={receiptTokenData}
      title={i18n.get("IOS_RECEIPT_TOKEN_DATA")}
      shouldBeFlagged={false}
      titleKey={"IOS_RECEIPT_TOKEN_DATA"}
    />
  );
});

export default ObtainIosReceiptTokensData;
